<template>
  <div class="right-groups">
    <mainmenu selected="right-groups"></mainmenu>

    <div class="container">
      <h1>{{ $t("right_groups.page_title") }}</h1>
      
      <p>
        <el-button @click='add_item()'>{{ $t("add_item") }}</el-button>
      </p>

      <el-table :data="Results" style="width: 100%" v-loading="tableLoadingVisible">
        <el-table-column prop="Name" :label="$t('right_groups.name')"></el-table-column>

        <el-table-column fixed="right" :label="$t('operations')" width="120">
          <template slot-scope="scope">
            <el-button @click="edit_item(scope.row)"   type="text" size="small">{{ $t("edit") }}</el-button>
            <el-button @click="delete_item(scope.row)" type="text" size="small">{{ $t("delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>
    </div>
    <right-groups-dialog ref="item_dialog" @save='refresh_info' />
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import RightGroupsDialog from "./../views/dialogs/RightGroupsDialog";

export default {
  name: "right_groups",
  components: {
    "mainmenu": MainMenu,
    "right-groups-dialog": RightGroupsDialog
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: {},
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] }
    }
  },
  methods: {
     refresh_info: function() {
       this.tableLoadingVisible = true;
       this.$http
          .post('right_groups/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          });
    },
    add_item: function(){
      this.$refs.item_dialog.show_me();
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    delete_item: function(item){
       this.$confirm( this.$t("confirm_delete"), this.$t("warning_title"), { 
         confirmButtonText: this.$t("confirm"), 
         cancelButtonText: this.$t("cancel"), 
         type: 'warning'
        }).then(() => {
          this.tableLoadingVisible = true;
          this.$http
              .post('right_groups/delete_item',  { object: item } )
              .then(function (response) {
                this.tableLoadingVisible = false;
                if( settings.verify_response(response, this.$rights)) {
                  this.refresh_info();
                } else {
                  this.$router.push("/");
                }
              });
        }).catch(()=>{ });
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>

</style>